/**
 * High level router.
 *
 * Note: It's recommended to compose related routes in internal router
 * components (e.g: `src/app/modules/Auth/pages/AuthPage`, `src/app/BasePage`).
 */

import React from 'react';
import { Navigate, Routes, Route } from 'react-router-dom';
import { shallowEqual, useSelector } from 'react-redux';
import { Layout } from '../_metronic/layout';
import BasePage from './BasePage';
import { Logout, AuthPage } from './modules/Auth';
// import ErrorsPage from "./modules/ErrorsExamples/ErrorsPage";

export function AppRoutes() {
  const { isAuthorized } = useSelector(
    () => ({
      isAuthorized: localStorage.getItem('adminToken') !== null,
    }),
    shallowEqual,
  );
  return (
    <Routes>
      {/* <Route path="/error" element={<ErrorsPage />} /> */}
      <Route
        path="/logout"
        element={<Logout />}
      />
      {!isAuthorized ? (
        <>
          {' '}
          <Route
            path="/auth/*"
            element={<AuthPage />}
          />
          <Route
            path="*"
            element={
              <Navigate
                to="/auth/login"
                replace
              />
            }
          />{' '}
        </>
      ) : (
        <>
          <Route
            path="/auth/*"
            element={<Navigate to="/*" />}
          />
          <Route
            path="/*"
            element={<BasePage />}
          />
        </>
      )}
    </Routes>
    // <Routes>
    //   {console.log(isAuthorized)}
    //   {!isAuthorized ? (
    //     /*Render auth page when user at `/auth` and not authorized.*/
    //     <Route path="/auth/*" element={<AuthPage />} />
    //   ) : (
    //     /*Otherwise redirect to root page (`/`)*/
    //     <Route path="/auth" element={<Navigate to="/" />} />
    //   )}

    //   <Route path="/error" element={<ErrorsPage />} />
    //   <Route path="/logout" element={<Logout />} />

    //   {!isAuthorized ? (
    //     /*Redirect to `/auth` when user is not authorized*/
    //     <Route path="*" element={<Navigate to="/auth/login" replace />} />
    //   ) : (
    //     <Route
    //       path="/"
    //       element={
    //         <Layout>
    //           <BasePage />
    //         </Layout>
    //       }
    //     />
    //   )}
    // </Routes>
  );
}
